import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
const NotFound = () => {
    useEffect(() => {
        window.scrollTo(0, 0)
    }, []);
    return (
        <main className="flex justify-center p-3 sm:p-16 min-h-screen" >
            <div className="text-center pt-8 text-red-600 w-full max-w-xl">
                <h1 className="text-6xl font-bold font-play">404</h1>
                <h1 className="text-4xl py-8 font-Cormorant-Garamond">oops! Page not found</h1>
                <p className="text-xl pb-8 px-12 font-Cormorant-Garamond">Oops! The page you are looking for does not exist. It might have been moved or deleted.</p>
                <button className="btn btn-sm capitalize w-40 h-9 font-play font-light rounded text-sm  text-green-400 hover:text-white bg-[#00283ac9] hover:bg-green-600 transition duration-150 ease-in-out border-[1px] border-green-900 hover:border-green-600">
                    <Link to='/'> HOME</Link>
                </button>
            </div>
        </main>
    );
};

export default NotFound; <h2>Not Found</h2>